import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { fetchServiceBySlug } from '../helpers/contentfulHelper';
import styles from '../styles/ServiceDetailPage.module.css';

const ServiceDetailPage = ({ setBreadcrumbLabel }) => {
  const { slug } = useParams();
  const [service, setService] = useState(null);

  useEffect(() => {
    const loadService = async () => {
      const data = await fetchServiceBySlug(slug);
      setService(data);

      if (data && setBreadcrumbLabel) {
        setBreadcrumbLabel(data.fields.title);
      }
    };

    loadService();
  }, [slug, setBreadcrumbLabel]);

  if (!service) return null;

  const { title, image, copy, gallery } = service.fields;

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>

        <Link to="/services" className={styles.backLink}>
          ← Back to Our Services
        </Link>

        <h1 className={styles.title}>{title}</h1>

        {image && (
          <img
            src={`https:${image.fields.file.url}`}
            alt={title}
            className={styles.image}
          />
        )}

        <div className={styles.copy}>
          {documentToReactComponents(copy)}
        </div>

        {/* ✅ GALLERY */}
        {gallery?.fields?.images?.length > 0 && (
          <div className={styles.gallerySection}>
            {gallery.fields.caption && (
              <p className={styles.galleryCaption}>
                {gallery.fields.caption}
              </p>
            )}

            <div className={styles.galleryGrid}>
              {gallery.fields.images.map((img) => (
                <img
                  key={img.sys.id}
                  src={`https:${img.fields.file.url}`}
                  alt={img.fields.title || title}
                  className={styles.galleryImage}
                />
              ))}
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default ServiceDetailPage;